<!--
*@KjfxPage
*@author Ys
*@date 2023/1/6 17:11
-->
<template>
    <div id="mainContainer">
      <div id="headTitle"> </div>
      <el-card id="box-card" :style="{height:tabHeight}">
       <el-button v-if="$route.query.loginType==='local'" plain style="float: right;" @click="loginOut">退出</el-button>
        <br>
        <p id="titileStyle" >建设项目选址空间分析</p>
        <fxfa-page v-if="showFxfa" @checkFxfa="checkFxfa" @showRwList="showRwList"></fxfa-page>
        <fxrw-add-page v-if="showXzfx" :checkedFxfa="checkedFxfa" @backToFxfa="backToFxfa" @showRwList="showRwList"></fxrw-add-page>
        <kjfx-rw-list v-if="showKjfxRwList" @showRwList="showRwList" @backToFxfa="backToFxfa"></kjfx-rw-list>
      </el-card>
    </div>
</template>

<script>

  import API from '../../../api/ApiConfig'
  import {ajaxPost} from '../../../util/AjaxhttpRequest'
  import $ from 'jquery'
  import Cookie from 'cookies-js'
  import FxfaPage from './components/FxfaPage'
  import FxrwAddPage from './components/FxrwAddPage'
  import KjfxRwList from './components/KjfxRwList'
  export default {
    name: 'KjfxPage',
    props: [],
    components: {
      FxfaPage,
      FxrwAddPage,
      KjfxRwList
    },
    data () {
      return {
        tabHeight:window.innerHeight-100+"px",
        showFxfa:false,
        showXzfx:false,
        showKjfxRwList:false,
        fxfaList:[],
        checkedFxfa:''
      }
    },
    created(){
      this.checkLoginStatus();
    },
    mounted () {

    },
    methods: {
      checkLoginStatus(){
        //本地网站 手机号登陆
        if (this.$route.query.loginType==='local') {
          this.showFxfa=true;
        }else {
          //嵌入界面登陆访问
          this.verificationLogin();
        }

      },
      verificationLogin() {
        var self = this;
        var url = window.location.href;
        if (url.length <50) {
          window.location.href = "https://sfrz.shaanxi.gov.cn/sysauthserver/authorize?authCheck=true&needAuth=true&client_id=SN000000710&redirect_uri=" + window.location.href;
        } else {
          var urlPara = url.split("&");
          var urlParaValue = urlPara[1].split("=");
          var state = urlParaValue[1];
          if (state=='false') { //陕西政务网未登录
            window.location.href ="https://sfrz.shaanxi.gov.cn/#/login?client_name=null&response_type=code&client_id=SN000000710&redirect_uri="+encodeURIComponent(API.kjfxUrl);  //跳转至省平台登录界面
          } else {// 陕西政务网已经登录,进行查询用户信息
            if (url.indexOf("code")!=-1) {
              var codeStr = urlPara[0];
              var code = codeStr.substr(codeStr.indexOf("code")+5, codeStr.length);
              var parm =[]
              parm.push(code);
              ajaxPost(API.ZydjProvider, "getUserInfo",parm).then((res) => {
                Cookie.set('dllx',"2")
                let result = JSON.parse(res);
                let dlzh=result.userInfo.userMobile
                let userName=result.userInfo.userName
                let certNo=result.userInfo.certNo
                Cookie.set('dlzh',dlzh)
                Cookie.set('userName',userName)
                Cookie.set('certNo',certNo)
                if (!certNo){
                  //法人逻辑
                  ajaxPost(API.ZydjProvider, "getLegalPerson",parm).then((res) => {
                    let LegalPersonResult = JSON.parse(res);
                    dlzh=LegalPersonResult.userInfo.certificateSno
                    userName=LegalPersonResult.userInfo.corpName
                    certNo=LegalPersonResult.userInfo.legalCertno

                    Cookie.set('dlzh',dlzh)
                    Cookie.set('userName',userName)
                    Cookie.set('certNo',certNo)

                    self.generateToken(dlzh);
                  })
                }else {
                 self.generateToken(dlzh);
                }


              }).catch((err) => {
                console.log(err)
                window.location.href ="https://sfrz.shaanxi.gov.cn/sysauthserver/authorize?response_type=code&client_id=SN000000710&redirect_uri="+encodeURIComponent(API.kjfxUrl);  //获取省平台获取授权码
              })
            } else {
              window.location.href ="https://sfrz.shaanxi.gov.cn/sysauthserver/authorize?response_type=code&client_id=SN000000710&redirect_uri="+encodeURIComponent(API.kjfxUrl);  //获取省平台获取授权码
            }
          }
        }
      },
      generateToken(dlzh){
        let self =this;
        ajaxPost(API.kjfxUserProvider,"generateToken",["",dlzh]).then(tokenInfo=>{
          Cookie.set('wwJcptToken',tokenInfo)
          self.showFxfa=true;
        }).catch(err=>{
          self.$message.error(err)
        })
      },
      loginOut(){
        this.$confirm('确认退出当前系统?', '操作确认', {
          confirmButtonText: '退出',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          Cookie.expire('dlzh',new Date())
          Cookie.expire('dllx',new Date())
          Cookie.expire('wwJcptToken',new Date())
          this.$router.push("/login");
        })
      },
      showRwList(){
        this.showFxfa=false;
        this.showXzfx=false
        this.showKjfxRwList=true;

      },
      checkFxfa(fxfa){
        this.showFxfa=false
        this.checkedFxfa=fxfa;
        this.showXzfx=true
      },
      backToFxfa(){
        this.showXzfx=false
        this.showKjfxRwList=false
        this.checkedFxfa='';
        this.showFxfa=true
      },
    },
  }
</script>

<style scoped>
  #mainContainer {
    background: url('../../../assets/login_bj.jpg');
    background-size: 100% 100%;
    height: 100%;
    position: fixed;
    width: 100%;
    overflow: hidden;
  }
  #headTitle{
    width: 800px;
    margin: 3% auto;
    padding-top: 100px;
    /*background-image: url('../../../assets/toplogo.png');*/
    background-size: 100% 100%;
  }
  #titileStyle{
    font-family: SourceHanSansSC;
    font-weight: 700;
    font-size: 36px;
    color: rgb(32, 133, 234);
    font-style: normal;
    letter-spacing: 0px;
    line-height: 52px;
    text-decoration: none;
  }
  /deep/ .el-card{
    /*存在标题样式*/
    /*position: absolute; left: 50%; top: 58%;*/
    position: absolute; left: 50%; top: 50%;
    transform: translate(-50%, -50%);
    height: 80%;
    width: 90%;
  }
  #box-card{
    overflow-y: auto;
    width: 1458px;
    /*存在标题样式*/
    /*height: 750px;*/
    /*height: 850px;*/
    border-color: rgb(187, 187, 187);
    border-width: 1px;
    border-style: solid;
    border-radius: 5px;
    font-size: 14px;
    padding: 0px;
    text-align: center;
    line-height: 20px;
    font-weight: normal;
    font-style: normal;
    background: rgb(255, 255, 255);
  }


</style>




// WEBPACK FOOTER //
// src/components/kjfx/main/KjfxPage.vue